"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _svgIcon = require("../SvgIcon");
var _default = (0, _svgIcon).makeIcon("Icon16ClockOurline", "clock_ourline_16", "0 0 17 16", '<symbol fill="none" viewBox="0 0 17 16" xmlns="http://www.w3.org/2000/svg" id="clock_ourline_16"><g clip-rule="evenodd" fill="currentColor" fill-rule="evenodd"><path d="M8.02 14.5a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13zm0 1.5a8 8 0 1 0 0-16 8 8 0 0 0 0 16z" /><path d="M10.67 11.085a.75.75 0 0 1-1.005.336l-2.5-1.25A.75.75 0 0 1 6.75 9.5V5.25a.75.75 0 0 1 1.5 0v3.786l2.085 1.043a.75.75 0 0 1 .336 1.006z" /></g></symbol>', 17, 16);
exports.default = _default;
